import { ADD_BOOKING, REMOVE_BOOKING } from "./actionTypes";

const initialState = {
    bookings: [],
    totalBookings: 0
}

const bookingReducer = (state=initialState, action) => {
    switch (action.type) {
        case ADD_BOOKING:
            return {
                ...state,
                bookings: [...state.bookings, action.payload],
                totalBookings: state.totalBookings + 1
            }
              
        case REMOVE_BOOKING:
            return {
                ...state,
                bookings: state.bookings.filter((booking) => booking.id !== action.payload),
                totalBookings: state.totalBookings - 1
            }

        default:
            return state
    }
}


export default bookingReducer;